module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Treytorrens_(Vaud)-a77347f22ea849ba8e6245973150498c.svg";